export default "__VITE_ASSET__D6DqE8jM__"